import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileDownloadState } from "../../models/FileDownload.model";
import {
  downloadFile,
  downloadAndSaveFile,
  openFileInNewTab,
} from "../thunks/fileDownloadThunks";

const initialState: FileDownloadState = {
  isDownloading: false,
  downloadProgress: 0,
  error: null,
  lastDownloadedFile: null,
};

const fileDownloadSlice = createSlice({
  name: "fileDownload",
  initialState,
  reducers: {
    // 🔥 איפוס שגיאות
    clearError: (state) => {
      state.error = null;
    },

    // 🔥 איפוס מצב הורדה
    resetDownloadState: (state) => {
      state.isDownloading = false;
      state.downloadProgress = 0;
      state.error = null;
      state.lastDownloadedFile = null;
    },

    // 🔥 עדכון התקדמות (לשימוש עתידי)
    updateDownloadProgress: (state, action: PayloadAction<number>) => {
      state.downloadProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    // 🔥 downloadFile cases
    builder
      .addCase(downloadFile.pending, (state) => {
        state.isDownloading = true;
        state.error = null;
        state.downloadProgress = 0;
      })
      .addCase(downloadFile.fulfilled, (state, action) => {
        state.isDownloading = false;
        state.downloadProgress = 100;
        state.lastDownloadedFile = action.payload.filename;
        state.error = null;
      })
      .addCase(downloadFile.rejected, (state, action) => {
        state.isDownloading = false;
        state.downloadProgress = 0;
        state.error = action.payload || "שגיאה בהורדת הקובץ";
      });

    // 🔥 downloadAndSaveFile cases
    builder
      .addCase(downloadAndSaveFile.pending, (state) => {
        state.isDownloading = true;
        state.error = null;
      })
      .addCase(downloadAndSaveFile.fulfilled, (state, action) => {
        state.isDownloading = false;
        state.lastDownloadedFile = action.payload;
        state.error = null;
      })
      .addCase(downloadAndSaveFile.rejected, (state, action) => {
        state.isDownloading = false;
        state.error = action.payload || "שגיאה בהורדה ושמירת הקובץ";
      });

    // 🔥 openFileInNewTab cases
    builder
      .addCase(openFileInNewTab.pending, (state) => {
        state.isDownloading = true;
        state.error = null;
      })
      .addCase(openFileInNewTab.fulfilled, (state, action) => {
        state.isDownloading = false;
        state.lastDownloadedFile = action.payload;
        state.error = null;
      })
      .addCase(openFileInNewTab.rejected, (state, action) => {
        state.isDownloading = false;
        state.error = action.payload || "שגיאה בפתיחת הקובץ";
      });
  },
});

export const { clearError, resetDownloadState, updateDownloadProgress } =
  fileDownloadSlice.actions;

// 🔥 Selectors
export const selectFileDownloadState = (state: {
  fileDownload: FileDownloadState;
}) => state.fileDownload;
export const selectIsDownloading = (state: {
  fileDownload: FileDownloadState;
}) => state.fileDownload.isDownloading;
export const selectDownloadError = (state: {
  fileDownload: FileDownloadState;
}) => state.fileDownload.error;
export const selectLastDownloadedFile = (state: {
  fileDownload: FileDownloadState;
}) => state.fileDownload.lastDownloadedFile;

export default fileDownloadSlice.reducer;
